var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V15.8333C2.5 16.7542 3.24583 17.5 4.16667 17.5H10.5175V11.6992H8.565V9.42833H10.5175V7.7575C10.5175 5.82083 11.7017 4.765 13.43 4.765C14.0125 4.76333 14.5942 4.79333 15.1733 4.8525V6.8775H13.9833C13.0417 6.8775 12.8583 7.3225 12.8583 7.97917V9.425H15.1083L14.8158 11.6958H12.845V17.5H15.8333C16.7542 17.5 17.5 16.7542 17.5 15.8333V4.16667C17.5 3.24583 16.7542 2.5 15.8333 2.5Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGrayIcon);
export default __webpack_public_path__ + "static/media/Facebook_gray_icon.87a022eb7bc3a2abc8b7859462a76f7d.svg";
export { ForwardRef as ReactComponent };